import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';

import Handlers from '../dispatcher/Handlers';
import VenueApi from '../server/VenueApi';

export default {

    getAll: function(params) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_LIST_ERROR);

        return VenueApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_INFO);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_INFO_ERROR);

        return VenueApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_INFO_ERROR);

        return VenueApi.save(entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_UPDATE_ERROR);

        return VenueApi.update(id, entity)
            .then(handleSuccess, Handlers._handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_DELETE_ERROR);

        return VenueApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED);
        const handleError = Handlers.createErrorHandler(ActionTypes.SEARCH_ERROR);

        return VenueApi.search(searchText)
            .then(handleSuccess, handleError);
    },

    listAssets: (venueId) => {
        const types = {
            request:    ActionTypes.VENUE_ASSET_LIST_REQUEST,
            success:    ActionTypes.VENUE_ASSET_LIST_SUCCESS,
            failure:    ActionTypes.VENUE_ASSET_LIST_FAILURE
        };

        return CentricDispatcher.dispatchAsync(VenueApi.listAssets(venueId), types, {venueId});
    },

    addAsset: (venueId, assetId) => {
        const types = {
            request:    ActionTypes.VENUE_ASSET_ADD_REQUEST,
            success:    ActionTypes.VENUE_ASSET_ADD_SUCCESS,
            failure:    ActionTypes.VENUE_ASSET_ADD_FAILURE
        };

        return CentricDispatcher.dispatchAsync(VenueApi.addAsset(venueId, assetId), types, {venueId, assetId});
    },

    saveAsset: function(id, asset) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_ASSET_SAVE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_ASSET_SAVE_ERROR);

        return VenueApi.saveAsset(id, asset)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    removeAsset: function(venueId, assetId) {
        const types = {
            request:    ActionTypes.VENUE_ASSET_REMOVE_REQUEST,
            success:    ActionTypes.VENUE_ASSET_REMOVE_SUCCESS,
            failure:    ActionTypes.VENUE_ASSET_REMOVE_FAILURE
        };

        return CentricDispatcher.dispatchAsync(VenueApi.removeAsset(venueId, assetId), types, {venueId, assetId});
    },

    getLocations: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_LOCATION_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_LOCATION_LIST_ERROR);

        return VenueApi.getLocations(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    addLocation: function(id, locationId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_LOCATION_SAVE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_LOCATION_SAVE_ERROR);

        return VenueApi.addLocation(id, locationId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    removeLocation: function(id, locationId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_LOCATION_DELETE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_LOCATION_DELETE_ERROR, ActionTypes.FORM_SUBMIT_ERROR);

        return VenueApi.removeLocation(id, locationId)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getEvents: (id, data) => {

        const types = {
            success:    ActionTypes.VENUE_EVENT_LIST,
            failure:    ActionTypes.VENUE_EVENT_LIST_ERROR
        };

        return CentricDispatcher.dispatchAsync(VenueApi.getEvents(id, data), types, {data});
    },
    
    getContacts: function(id) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_CONTACT_LIST);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_CONTACT_LIST_ERROR);
        
        return VenueApi.getContacts(id)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    addContact: function(id, contactId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_CONTACT_ADD);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_CONTACT_ADD_ERROR);
        
        return VenueApi.addContact(id, contactId)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },
    
    removeContact: function(id, contactId) {
        const handleSuccess = Handlers.createSuccessHandler(ActionTypes.VENUE_CONTACT_REMOVE);
        const handleError = Handlers.createErrorHandler(ActionTypes.VENUE_CONTACT_REMOVE_ERROR);
        
        return VenueApi.removeContact(id, contactId)
            .then(handleSuccess, handleError)
            .catch(Handlers._handleException);
    },

};
